document.addEventListener('DOMContentLoaded', function ()  {
  document.querySelectorAll('.element-video video').forEach(
    /**
     * @param {HTMLVideoElement} video
     */
    async (video) => {
      await video.play();
    });
});
